/**
 * gift-guard.js - Filet de securite panier pour les produits-cadeau a 0 EUR.
 * TOUS LES MARCHES depuis le 20/10/2026 (avant : Suisse seulement). Les cadeaux FR, CH et DE
 * sont desormais des articles a 0 EUR, plus aucune remise ne les rend gratuits, donc le seuil
 * d'obtention et le plafond d'un exemplaire ne tiennent que par ce script.
 *
 * Cas NORMAL : c'est auto-gift.js qui ajoute le cadeau au seuil (90 EUR) et le retire en dessous.
 * Ce script est le FILET si un bug laisse le cadeau 0 EUR au panier sans le seuil :
 *   - il RETIRE automatiquement le cadeau du panier,
 *   - affiche un petit message expliquant que le montant n'est pas suffisant,
 *   - bloque le paiement le temps que le panier se remette a jour.
 * Il bloque aussi si le cadeau 0 EUR est present en quantite > 1 (l'offre n'en offre qu'un).
 * Il NE surveille QUE les vrais produits a 0 EUR (jamais un produit a prix reel comme le Cahier).
 * Il NE re-ajoute PAS le cadeau (role d'auto-gift.js) pour eviter tout conflit.
 */
(function () {
  'use strict';

  // ---- Tous les marches de la boutique (FR, CH, DE) ----
  // Garde-fou : on ne tourne que sur les domaines de la boutique, jamais ailleurs.
  if (!/(^|\.)(editions-animees\.(com|ch|de)|myshopify\.com)$/i.test(location.hostname)) return;

  var CHECKOUT_SEL = 'button[name="checkout"], .cart__checkout-button';
  var DYN_SEL = '.cart__dynamic-checkout-buttons, .additional-checkout-buttons, .shopify-payment-button, .dynamic-checkout__content';
  var LINK_SEL = 'a[href*="/checkout"], a[href*="/checkouts"]';
  var MSG = 'gift-guard-msg';
  var isBlocked = false, blockInfo = null, busy = false, pending = false, removing = false;

  function getGifts() {
    try {
      var el = document.getElementById('auto-gift-config');
      if (!el) return [];
      var c = JSON.parse(el.textContent);
      if (!c.enabled || !Array.isArray(c.gifts)) return [];
      return c.gifts.filter(function (g) { return g && g.variantId && g.threshold > 0; });
    } catch (e) { return []; }
  }
  function money(v) {
    try { return v.toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' }); }
    catch (e) { return v + ' €'; }
  }
  function msgText() {
    if (!blockInfo) return '';
    var name = blockInfo.name ? ('« ' + blockInfo.name + ' »') : 'Ce cadeau';
    if (blockInfo.type === 'qty') return '🎁 ' + name + ' est limité à 1 exemplaire offert. Retirez les exemplaires en trop pour passer au paiement.';
    return '🎁 ' + name + ' est offert dès ' + money(blockInfo.threshold) + ' d’achat — il vous manque ' + money(blockInfo.missing) + '. Ajoutez des articles pour en profiter.';
  }
  function showMsg() {
    var boxes = [];
    [].slice.call(document.querySelectorAll(CHECKOUT_SEL)).forEach(function (btn) {
      var box = btn.closest('.button-container, .cart__ctas') || btn.parentElement;
      if (box && boxes.indexOf(box) === -1) boxes.push(box);
    });
    boxes.forEach(function (box) {
      var parent = box.parentNode; if (!parent) return;
      var prev = box.previousElementSibling;
      var m = (prev && prev.classList && prev.classList.contains(MSG)) ? prev : null;
      if (!m) {
        m = document.createElement('div'); m.className = MSG; m.setAttribute('role', 'alert');
        m.style.cssText = 'margin:0 0 12px;padding:11px 14px;background:#fff4e5;border:1px solid #f0c67c;border-radius:10px;font-size:.86em;line-height:1.4;color:#5c4300;text-align:center;';
        parent.insertBefore(m, box);
      }
      m.textContent = msgText();
    });
  }
  function clearMsg() { [].slice.call(document.querySelectorAll('.' + MSG)).forEach(function (n) { n.remove(); }); }

  function applyUI() {
    var btns = [].slice.call(document.querySelectorAll(CHECKOUT_SEL));
    var dyns = [].slice.call(document.querySelectorAll(DYN_SEL));
    if (isBlocked) {
      btns.forEach(function (b) { b.setAttribute('disabled', 'disabled'); b.setAttribute('aria-disabled', 'true'); b.dataset.giftGuard = '1'; });
      dyns.forEach(function (w) { w.dataset.giftGuard = '1'; w.style.display = 'none'; });
      showMsg();
    } else {
      btns.forEach(function (b) { if (b.dataset.giftGuard) { b.removeAttribute('disabled'); b.removeAttribute('aria-disabled'); delete b.dataset.giftGuard; } });
      dyns.forEach(function (w) { if (w.dataset.giftGuard) { w.style.display = ''; delete w.dataset.giftGuard; } });
      clearMsg();
    }
  }

  // Re-rendu du tiroir apres modif du panier (meme mecanisme qu'auto-gift.js)
  function refreshUI() {
    var mc = document.querySelector('mini-cart');
    var ci = document.querySelector('cart-items');
    var sections = [];
    if (mc && typeof mc.getSectionsToRender === 'function') sections = mc.getSectionsToRender().map(function (s) { return s.section || s.id; }).filter(Boolean);
    else if (ci && typeof ci.getSectionsToRender === 'function') sections = ci.getSectionsToRender().map(function (s) { return s.section; }).filter(Boolean);
    sections = sections.filter(function (v, i, a) { return v && a.indexOf(v) === i; });
    if (!sections.length) return Promise.resolve();
    return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: {}, sections: sections, sections_url: window.location.pathname }) })
      .then(function (r) { return r.json(); })
      .then(function (data) { if (!data || !data.sections) return; if (mc && typeof mc.renderContents === 'function') mc.renderContents(data); else if (ci && typeof ci.renderContents === 'function') ci.renderContents(data); })
      .catch(function () {});
  }

  // FILET : retrait auto du cadeau 0 EUR non merite
  function removeGiftVariant(vid) {
    if (removing) return;
    removing = true;
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: Number(vid), quantity: 0 }) })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function () { return refreshUI(); })
      .catch(function () {})
      .then(function () { removing = false; setTimeout(schedule, 300); });
  }

  function evaluate() {
    var gifts = getGifts();
    if (!gifts.length) { isBlocked = false; blockInfo = null; applyUI(); return Promise.resolve(); }
    var vids = gifts.map(function (g) { return String(g.variantId); });
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        var other = items.filter(function (it) { return vids.indexOf(String(it.variant_id)) === -1; }).reduce(function (s, it) { return s + (it.original_line_price != null ? it.original_line_price : it.line_price); }, 0);
        var below = null, overqty = null;
        for (var i = 0; i < gifts.length; i++) {
          var vid = String(gifts[i].variantId);
          var line = items.filter(function (it) { return String(it.variant_id) === vid; });
          if (!line.length) continue;
          // Ne surveiller QUE les vrais produits-cadeaux a 0 EUR (pas le Cahier a prix reel)
          if (!line.every(function (it) { return it.original_price === 0; })) continue;
          var gq = line.reduce(function (s, it) { return s + it.quantity; }, 0);
          var thr = Math.round(gifts[i].threshold * 100);
          var nm = line[0] ? (line[0].product_title || line[0].title || null) : null;
          if (gq > 0 && other < thr) { below = { g: gifts[i], vid: vid, nm: nm, thr: thr }; break; }
          if (gq > 1) { overqty = { g: gifts[i], vid: vid, nm: nm }; break; }
        }
        if (below) {
          // Sous le seuil : message + blocage, ET on retire le cadeau (filet si auto-gift.js ne l'a pas fait)
          blockInfo = { type: 'amount', threshold: below.g.threshold, missing: (below.thr - other) / 100, name: below.nm };
          isBlocked = true; applyUI();
          removeGiftVariant(below.vid);
        } else if (overqty) {
          blockInfo = { type: 'qty', threshold: overqty.g.threshold, name: overqty.nm };
          isBlocked = true; applyUI();
        } else {
          isBlocked = false; blockInfo = null; applyUI();
        }
      })
      .catch(function () {});
  }

  function schedule() {
    if (busy) { pending = true; return; }
    busy = true;
    setTimeout(function () {
      var done = function () { busy = false; if (pending) { pending = false; schedule(); } };
      var p = evaluate(); if (p && p.then) p.then(done, done); else done();
    }, 100);
  }

  // Gate ultime : interception au clic (survit aux re-rendus du tiroir)
  document.addEventListener('click', function (e) {
    if (!isBlocked || !e.target || !e.target.closest) return;
    if (e.target.closest(CHECKOUT_SEL + ', ' + DYN_SEL + ', ' + LINK_SEL)) { e.preventDefault(); e.stopImmediatePropagation(); applyUI(); }
  }, true);
  document.addEventListener('submit', function (e) {
    if (!isBlocked) return;
    var f = e.target;
    if (f && f.querySelector && f.querySelector(CHECKOUT_SEL)) { e.preventDefault(); e.stopImmediatePropagation(); applyUI(); }
  }, true);

  document.addEventListener('cart:updated', schedule);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') { try { subscribe(PUB_SUB_EVENTS.cartUpdate, schedule); } catch (e) {} }
  var nf = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url ? input.url : '');
    var p = nf.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(url)) { p.then(function () { schedule(); }).catch(function () {}); }
    return p;
  };
  var moT = null;
  var mo = new MutationObserver(function () { if (!isBlocked) return; clearTimeout(moT); moT = setTimeout(applyUI, 40); });
  try { mo.observe(document.documentElement, { childList: true, subtree: true }); } catch (e) {}
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule); else schedule();
  setInterval(schedule, 4000);
})();
